
import { useContext } from 'react';
import RegisterChildCard from '../registerChildCard.jsx/RegisterChildCard';
import Button from '../buttons/Button';
import { registrationContex } from '../../service/RegisrationContext'
import useUpdateKidCB from '../../service/useUpdateKidCB';
import { kidRowsAllValid } from '../../service/planUtils';
import { familyTierAvailable, FAMILY_MORE_CHILDREN } from '../../service/familyPlanUtil';

export default function RegistrationChildren({ onCompleted }) {

    const registration = useContext(registrationContex)
    const { kids, planMode, familySubMode, familyChildrenCount, familyPlans, selectPlanMode, selectFamilySubMode } = registration

    //update kid fields via CallBack fn
    const { addKid, updateKidCB, removeKid, addPlanRow, removePlanRow } = useUpdateKidCB(registration)

    const isFamily = planMode === 'family';
    const familyKid = kids?.[0];
    const familyHasChildren = isFamily && familySubMode === 'hasChildren';
    // The family plan tier is (children count, oldest child age) - no tier fits => the donor is blocked
    const familyTooManyChildren = familyHasChildren && familyChildrenCount === FAMILY_MORE_CHILDREN;
    const familyCountSelected = familyHasChildren && !!familyChildrenCount && !familyTooManyChildren;
    const familyAgeBlocked = familyCountSelected && familyKid?.age != null && !familyTierAvailable(familyPlans, familyChildrenCount, familyKid.age);
    const familyBlocked = familyTooManyChildren || familyAgeBlocked;

    // Mode-aware completion / add validation
    let completeDisabled;
    if (!isFamily) {
        completeDisabled = kids?.some(kid =>
            (!kid.preBorn && !kid.name) ||
            (!kid.preBorn && kid?.idType === 'Person_Id' && kid?.personIdValidation?.invalid) ||
            !((kid.age !== null && kidRowsAllValid(kid)) &&
                ((kid.relationshipType && kid.relationshipType !== 'Other') || (kid.relationshipType === 'Other' && kid.relationshipOther)) &&
                (kid.preBorn || (kid.birthday && ((kid.idType === 'Person_Id' && kid.personId) || (kid.idType === 'Passport_Id' && kid.passportId)))))
        );
    } else if (familySubMode === 'preBorn') {
        completeDisabled = !(familyKid?.plan && familyKid?.loanAmount > 0);
    } else if (familySubMode === 'hasChildren') {
        completeDisabled = familyBlocked || !familyCountSelected || !familyKid?.name ||
            (familyKid?.idType === 'Person_Id' && familyKid?.personIdValidation?.invalid) ||
            !(familyKid?.plan && familyKid?.age != null && familyKid?.loanAmount > 0 && familyKid?.birthday &&
                ((familyKid?.idType === 'Person_Id' && familyKid?.personId) || (familyKid?.idType === 'Passport_Id' && familyKid?.passportId)));
    } else {
        completeDisabled = true; // family selected but no sub-mode chosen yet
    }

    // Constant heading per mode (standard vs family)
    const heading = isFamily
        ? 'בחרו מסלול בתוכנית המשפחתית'
        : 'מלאו את פרטי הילדים שתרצו לצרף לגמ"ח';

    return (
        <div>
            {!!heading && <div role="heading" aria-level="2" className='heading-h3'>{heading}</div>}

            {isFamily &&
                <div className="family-submode" role="radiogroup">
                    <div className="radio-wrapper">
                        <label htmlFor="family-preborn">
                            <input type="radio" name="family-submode" id="family-preborn" checked={familySubMode === 'preBorn'} onChange={() => selectFamilySubMode('preBorn')} />
                            עדיין אין לי ילדים
                        </label>
                        <label htmlFor="family-haschildren">
                            <input type="radio" name="family-submode" id="family-haschildren" checked={familySubMode === 'hasChildren'} onChange={() => selectFamilySubMode('hasChildren')} />
                            יש לי כבר ילדים
                        </label>
                    </div>
                </div>
            }

            {!isFamily &&
                <div className="cards-wrapper">
                    {kids?.map((kid, index) => <RegisterChildCard key={kid.id} index={index} {...kid} updateCB={updateKidCB} removeKid={removeKid} addPlanRow={addPlanRow} removePlanRow={removePlanRow} />)}
                    <Button size='small' color={'white-button'} className='add-child-button' disabled={completeDisabled} onClick={addKid} icon="plus-circle" label='הוסף ילד/ה' />
                </div>
            }

            {isFamily && familySubMode &&
                <div className="cards-wrapper">
                    <RegisterChildCard key={familyKid.id} index={0} {...familyKid} updateCB={updateKidCB} removeKid={removeKid} familyMode familySubMode={familySubMode} />
                    {familyBlocked &&
                        <div className="family-age-blocked">
                            <p>{(familyTooManyChildren)
                                ? 'לפי מספר הילדים שלך אינך מתאים לתוכנית זו, באפשרותך לעבור לתוכניות הרגילות'
                                : 'לפי גיל הילד הגדול שלך אינך מתאים לתוכנית זו, באפשרותך לעבור לתוכניות הרגילות'}</p>
                            <Button size='small' onClick={() => selectPlanMode('standard')} label='מעבר לתוכניות הרגילות' />
                        </div>
                    }
                </div>
            }

            <Button onClick={onCompleted} label={isFamily ? "המשך" : "סיימתי למלא את כל פרטי הילדים"} disabled={completeDisabled || kids.length === 0} />
        </div>
    )
}
